// extracted by css-extract-rspack-plugin
export default {"PermissionTableContainer":"CollectionPermissionsModal-module__PermissionTableContainer___kwa1F"};